<template>
    <div class="dhuang">
        <img src="@/assets/image/daoh.png" alt="" @click="drawer = true" />
        <el-drawer
            title=""
            :visible.sync="drawer"
            :direction="direction"
            size="60%"
            :modal="false"
        >
            <router-link to="/">
                <p class="home">首页</p>
            </router-link>
            <router-link to="/preface">
                <p class="home">前言</p>
            </router-link>
            <router-link to="/invitation">
                <p class="home">邀请函</p>
            </router-link>
            <router-link to="/petrhome">
                <p class="home">工业产业投资方向及项目凝练</p>
            </router-link>
            <div class="list" v-for="item in list" :key="item.id">
                <router-link
                    :to="{
                        path: 'petrifaction',
                        query: {
                            id: item.id,
                        },
                    }"
                >
                    <p class="subpage">{{ item.name }}</p>
                </router-link>
            </div>
            <router-link to="/policy">
                <p class="home">工业产业投资政策要点</p>
            </router-link>
            <div class="list" v-for="item in ditel" :key="item.id">
                <router-link :to="{ path: 'poldtl', query: { id: item.id } }">
                    <p class="subpage">{{ item.name }}</p>
                </router-link>
            </div>
            <router-link to="/industrial">
                <p class="home">产业空间布局</p>
            </router-link>
            <router-link to="/topolo">
                <p class="home">兰州产业链招商拓扑图</p>
            </router-link>
        </el-drawer>
    </div>
</template>

<script>
import { getAction } from "@/api/manage.js";
export default {
    created() {
        this.loadData();
        this.ldData();
    },
    data() {
        return {
            ditel: [],
            list: [],
            drawer: false,
            direction: "rtl",
        };
    },
    watch: {
        $route: {
            handler(value) {
                this.drawer = false;

            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            getAction("/sys/category/loadTreeByCode", {
                pid: "1356812611114549249",
            }).then((res) => {
                if (res.success) {
                    this.ditel = res.result;
                }
            });
        },
        ldData() {
            getAction("/sys/category/loadTreeByCode", {
                pid: "1356815807157448706",
            }).then((res) => {
                if (res.success) {
                    this.list = res.result;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.dhuang {
    .home {
        font-size: 14px;
        font-weight: bold;
        line-height: 40px;
        letter-spacing: 1px;
        color: #ffffff;
        margin-left: 19px;
    }
    .subpage {
        font-size: 12px;
        font-weight: bold;
        line-height: 28px;
        letter-spacing: 1px;
        color: #ffffff;
        margin-left: 50px;
    }
    ::v-deep.el-drawer {
        background: rgba(216,174,101,0.93);
    }
    ::v-deep.el-drawer__header {
        margin: 0;
        padding: 10px 20px 0;
    }
    ::v-deep.el-drawer__body{
        overflow-y: auto;
        padding-bottom: 20px;
    }
}
</style>
